module.exports = __webpack_public_path__ + "img/signin-bg.46805559.png";